"use strict";

AquaTechTheme.registerModule('collection-bundle', null, function() {
    AquaTechTheme.CollectionBundle = {
        $: null,
        $jsDebug: null,
        DEBUG: true,

        onDocReady: function() {
            this.$ = AquaTechTheme.$;
            var $ = this.$;

            this.initRecommendations();
        },

        initRecommendations: function () {
          var self = this;
          var $ = self.$;

          var $productPanels = $('.product-collection-bundle .recommend-product');
          $productPanels.each(function() {
            var $productPanel = $(this);

            var $addToCart = $productPanel.find('.add-to-cart .button');
            $addToCart.on('click', function(e) {
              e.preventDefault();
              self.addToCartSingle($(this));
            });

            var $selectToggle = $productPanel.find('.select-toggle');
            $selectToggle.on('click', function(e) {
              e.preventDefault();
              var $selectedProductPanel = $(this).closest('.recommend-product.recommended');
              self.toggleRecommendedSelect($selectedProductPanel);
            });
          });

          var $totalPanel = $('.product-collection-bundle .recommend-product.totals');
          var $addSelectedButton = $totalPanel.find('.add-to-cart .button');
          $addSelectedButton.on('click', function(e) {
            e.preventDefault();
            self.addToCartSelected($(this));
          });

          var $selectToggle = $totalPanel.find('.select-toggle');
          $selectToggle.on('click', function(e) {
            e.preventDefault();
            self.toggleSelectAll($(this));
          });

          self.watchVariations();
          self.watchVariationSelectors();
          self.watchCart();

          self.updateRecommendedTotals();
        },

        toggleRecommendedSelect: function($productPanel, setState) {
          console.log('toggleRecommendedSelect', setState);
          var self = this;
          var $ = self.$;

          var state = $productPanel.attr('data-selected');
          var $stateToggle = $productPanel.find('.select-toggle');

          var newState = state == '' ? 'selected' : '';
          if (setState !== undefined) {
            newState = setState;
          }

          if (newState == 'selected') {
            $productPanel.attr('data-selected', 'selected');
            $stateToggle.addClass('selected');
          } else {
            $productPanel.attr('data-selected', '');
            $stateToggle.removeClass('selected');
          }

          self.updateRecommendedTotals();
        },

        toggleSelectAll: function($panel) {
          var self = this;
          var $ = self.$;

          var $bundle = $selectToggle.closest('.product-recommend-bundle');
          var $productPanels = $bundle.find(".recommend-product.recommended");
          var hasSelections = false;
          var allSelected = true;
          $productPanels.each(function() {
              var $productPanel = $(this);
              if ($productPanel.attr('data-selected') !== 'selected') {
                allSelected = false;
              }
          });

          $productPanels.each(function() {
              var $productPanel = $(this);
              if (allSelected) {
                self.toggleRecommendSelect($productPanel, '');
              } else if ($productPanel.attr('data-selected') !== 'selected') {
                self.toggleRecommendSelect($productPanel, 'selected');
              }
          });
        },

        priceSymbol: function() {
          var priceSymbol = '';
          switch (window.Shopify.currency.active) {
            case 'AUD':
              priceSymbol = '$';
              break;
            case 'USD':
              priceSymbol = '$';
              break;
            case 'GBP':
              priceSymbol = '£';
              break;
            case 'EUR':
              priceSymbol = '€';
              break;
            default:
              priceSymbol = '';
          }
          return priceSymbol;
        },

        updateRecommendedTotals: function() {
          var self = this;
          var $ = self.$;

          var $bundle = $(".product-recommend-bundle");
          var $products = $bundle.find('.recommend-product.recommended');
          var $total = $bundle.find('.recommend-product.totals');
          var totalPrice = 0;
          var numSelected = 0;
          $products.each(function() {
            var $product = $(this);
            if ($product.attr('data-selected') == 'selected') {
              totalPrice += parseFloat($product.data('price'));
              numSelected++;
            }
          });
          totalPrice = totalPrice.toFixed(2);
          $total.find('.total .price').html(self.priceSymbol() + totalPrice);

          var $totalAddToCart = $total.find('.add-to-cart .button');
          if (numSelected > 0) {
            $totalAddToCart.html('Add selected to cart').removeClass('disabled');
          } else {
            $totalAddToCart.html('No selection').addClass('disabled');
          }
        },

        addToCartSingle: function($button) {
          var self = this;
          var $ = self.$;

          var $selectedProductPanel = $button.closest('.recommend-product.recommended');

          var variantId = $selectedProductPanel.attr('data-variant-id');
          var $variantsSelect = $selectedProductPanel.find('.product-bundle-variant-select');
          if ($variantsSelect.length) {
            var $vSelected = $variantsSelect.find('option:selected');
            var selVariantId = $vSelected.attr('value');
            if (selVariantId) {
              variantId = selVariantId;
            }
          }

          var formData = {
            'items': [{
              'id': variantId,
              'quantity': 1
            }]
          };

          self.addToCartPost(formData, function() {
            self.addedSingleToCart($button);
          });
        },

        addedSingleToCart: function($addButton) {
          window.wetheme.toggleRightDrawer();
        },

        addToCartSelected: function($addAllButton) {
          var self = this;
          var $ = self.$;

          var $bundle = $addAllButton.closest('.product-recommend-bundle');
          var $selectedProducts = $bundle.find(".recommend-product.recommended[data-selected='selected']");

          var items = [];
          $selectedProducts.each(function() {
            var $selectedProductPanel = $(this);
            
            var variantId = $selectedProductPanel.attr('data-variant-id');
            var $variantsSelect = $selectedProductPanel.find('.product-bundle-variant-select');
            if ($variantsSelect.length) {
              var $vSelected = $variantsSelect.find('option:selected');
              var selVariantId = $vSelected.attr('value');
              if (selVariantId) {
                variantId = selVariantId;
              }
            }

            items.push({
              'id': variantId,
              'quantity': 1
            });
          });

          var formData = {
            'items': items
          };

          self.addToCartPost(formData, function() {
            self.addedSelectionToCart($addAllButton);
          });
        },

        addedSelectionToCart: function($addAllButton) {
          var self = this;

          var $totals = $('.recommend-product.totals');

          $addAllButton.html('Added to cart');

          window.wetheme.toggleRightDrawer();
        },

        addToCartPost: function(formData, callback) {
          var self = this;

          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          })
          .then(response => {
            if (response.ok) {
              if (callback) {
                callback();
              }
              self.triggerCartUpdate();
            }
          })
          .catch((error) => {
            console.log('Error:', error);
          });
        },

        /* Watch for cart mutation: */
        watchCart: function() {
          document.documentElement.addEventListener('wetheme-cart-update', (event) => {
            console.log('Cart updated.');
            AquaTechTheme.CollectionBundle.updateRecommendationsCartState();
          });

          AquaTechTheme.CollectionBundle.updateRecommendationsCartState();
        },

        /* Trigger cart update event */
        triggerCartUpdate: function() {
          var self = this;
          var $ = self.$;

          $.ajax({
            url: "/cart?view=compare",
            type: 'GET',
            success: function(response) {
              var e = JSON.parse(response);
              window.wetheme.updateCartDrawer(e);
              var cartEvent = new CustomEvent("wetheme-cart-update", {
                  detail: {
                      cart: e
                  }
              });
              document.documentElement.dispatchEvent(cartEvent);

              console.log('Update Cart');
              window.THEME_CART_HOOK.fetchCart();
            },
            error: function(xhr, ajaxOptions, thrownError) {
              console.log(xhr.status + ' ' + thrownError);
            }
          });
        },

        fetchCart: async function() {
            try {
                const languageUrl = document.getElementById("PageContainer").dataset.languageUrl;
                const e = languageUrl && "/" != languageUrl ? languageUrl : "",
                    t = await window.fetch(`${e}/cart?view=compare`);
                t.ok;
                const n = await t.json();
                this.cart = n, n.attributes.gift_note && (this.giftNote = n.attributes.gift_note), this.theme.updateCartDrawer(n)
            } catch (e) {
                console.error("Unable to fetch cart: ", e)
            }
        },

        /* Watch for variation pick changes on product */
        watchVariations: function() {
          var self = this;
          var $ = self.$;

          var $formInputs = $("form#AddToCartForm .swatch input");
          $formInputs.on('change', function() {
            var $input = $(this);
            console.log('input change', $input.val());
            self.applyCurrentProductVariation();
          });

          self.applyCurrentProductVariation();
        },

        watchVariationSelectors: function() {
          var self = this;
          var $ = self.$;

          var $recoProductVarSelectors = $('.recommend-product.recommended .product-bundle-variant-select');
          $recoProductVarSelectors.each(function() {
            var $recoProductVarSelector = $(this);
            self.sortVariationSelector($recoProductVarSelector);

            $recoProductVarSelector.on('change', function() {
              var $parentRecoProduct = $recoProductVarSelector.closest('.recommend-product.recommended');
              self.updateRecommendationCartStatus($parentRecoProduct);

              // Select if available and not in cart.
              var isAvailable = $parentRecoProduct.attr('data-product-available');
              var selVariantId = $recoProductVarSelector.find('option:selected').attr('value');          
              if (isAvailable && selVariantId.length > 0) {
                var productId = $parentRecoProduct.attr('data-product-id');    
                if (!self.isInCart(productId, selVariantId)) {
                  self.toggleRecommendedSelect($parentRecoProduct, 'selected');
                } else {
                  self.toggleRecommendedSelect($parentRecoProduct, '');
                }

              } else {
                self.toggleRecommendedSelect($parentRecoProduct, '');
              }
            });
          });
        },

        sortVariationSelector($select) {
          var self = this;
          var $ = self.$;

          var priorityString = $select.closest('.product-recommend-panel').attr('data-fits-brand');
          if (!priorityString) {
            return;
          }
          var fitsModels = $select.closest('.product-recommend-panel').attr('data-fits-models');          

          var $options = $select.find('option').detach();
          $options.sort(function(a, b) {
              var aContains = $(a).html().indexOf(priorityString) > -1;
              var bContains = $(b).html().indexOf(priorityString) > -1;

              if (aContains && !bContains) return -1; // Move 'a' up if it contains the string
              if (!aContains && bContains) return 1;  // Move 'b' up if it contains the string
              return 0;                               // Keep original order otherwise
          });
          $select.append($options);
          $select.prepend('<option value="" selected>Select an option...</option>');
          $select[0].selectedIndex = 0;
        },

        /* Update bundle display to reflect current variation */
        applyCurrentProductVariation: function() {
          var self = this;
          var $ = self.$;

          var currentVariantId = AquaTechTheme.getUrlParameter('variant');
          var $variantSpecs = $('.product-recommend-bundle .variant-prop');
          $variantSpecs.each(function() {
            var $vs = $(this);
            if ($vs.attr('data-variant-id') == currentVariantId) {
              var $bProd = $vs.closest('.recommend-product.recommended');
              $bProd.attr('data-variant-id', $vs.attr('data-variant-id'));
              $bProd.attr('data-price', $vs.attr('data-variant-price'));

              var $price = $bProd.find('.price .money .money');
              var fmtPrice = parseFloat($vs.attr('data-variant-price'));
              fmtPrice = self.priceSymbol() + fmtPrice.toFixed(2);
              $price.html(fmtPrice);
            }
          });

          self.updateRecommendationsCartState();
        },

        updateRecommendationsCartState: function() {
          var self = this;
          var $ = self.$;

          self.getCart(self.updateRecommendationsCartFetched);
        },

        /* Ajax Fetch cart contents */
        getCart: function(callback) {
          var self = this;
          var $ = self.$;

          $.ajax({
            url: "/cart.json",
            type: 'GET',
            success: function(response) {
              self.parseCart(response, callback);
            },
            error: function(xhr, ajaxOptions, thrownError) {
              console.log(xhr.status + ' ' + thrownError);
            }
          });
        },

        /* Extract product & variant ids from cart */
        parseCart: function(response, callback) {
          var self = this;

          self.cachedCartProducts = [];

          for (var ci = 0; ci < response.items.length; ci++) {
            var item = response.items[ci];
            self.cachedCartProducts[ci] = {
              product_id: item.product_id,
              variant_id: item.variant_id,
              qty: item.quantity
            }
          }

          callback();
        },

        updateRecommendationsCartFetched: function() {
          var self = AquaTechTheme.CollectionBundle;
          var $ = self.$;

          var $recoProducts = $('.recommend-product.recommended');
          $recoProducts.each(function() {
            var $recoProduct = $(this);
            self.updateRecommendationCartStatus($recoProduct);
          });

          self.updateRecommendedTotals();
        },

        updateRecommendationCartStatus: function($recommendedProduct) {
          console.log('updateRecommendationCartStatus...');
          
          var self = AquaTechTheme.CollectionBundle;
          var $ = self.$;

          var $button = $recommendedProduct.find('.add-to-cart .button');
          $button.removeClass('disabled');
          $button.html('Add to cart');

          var $selectToggle = $recommendedProduct.find('.select-toggle');
          $selectToggle.show();          
          
          var isAvailable = $recommendedProduct.attr('data-product-available');
          if (isAvailable == 'false') {
            $button.addClass('disabled');
            $button.html('Sold Out');
            $recommendedProduct.attr('data-selected', '');
            $selectToggle.removeClass('selected');   
            $selectToggle.hide();
            return;       
          }
 
          var currentProductId = $recommendedProduct.attr('data-product-id');
          var currentVariationId = $recommendedProduct.attr('data-variant-id');

          var $variantsSelect = $recommendedProduct.find('.product-bundle-variant-select');
          if ($variantsSelect.length) {
            var $vSelected = $variantsSelect.find('option:selected');
            var selVariantId = $vSelected.attr('value');
            if (selVariantId) {
              currentVariationId = selVariantId;
            }

            if (selVariantId == 0) {
                $button.addClass('disabled');
                $button.html('Select...');
                $recommendedProduct.attr('data-selected', '');
                $selectToggle.removeClass('selected');   
                $selectToggle.hide();            
                return;              
            }
          }          

          if (self.isInCart(currentProductId, currentVariationId)) {
            $button.addClass('disabled');
            $button.html('In cart');
            $recommendedProduct.attr('data-selected', '');
            $selectToggle.removeClass('selected');   
            $selectToggle.hide();
          }    
        },

        isInCart: function(productId, variationId) {
          var self = this;
         
          for (var ci = 0; ci < self.cachedCartProducts.length; ci++) {
              if (self.cachedCartProducts[ci].product_id == productId && 
                  self.cachedCartProducts[ci].variant_id == variationId) {
                console.log('yes');
                return true;
              }
          }   

          return false;
        }
    };

    AquaTechTheme.$(function() { AquaTechTheme.CollectionBundle.onDocReady(); });
});